import { Route } from '@angular/router';
import { entitlementsGuard, FeatureMappingEnum } from '@unified-ui/entitlements';
import { authenticationGuard } from '@unified-ui/shared/auth-lib';
import { PlatformComponent } from './platform.component';

export const appRoutes: Route[] = [
    {
        canActivate: [authenticationGuard],
        path: '',
        component: PlatformComponent,
        children: [
            // New paths
            // {
            //     path: 'data-solutions',
            //     data: { requiredEntitlement: { entitlement: FeatureMappingEnum.DATA_SOLUTIONS } },
            //     canActivate: [authenticationGuard, entitlementsGuard],
            //     loadChildren: () => import('./features/mediascope/mediascope.module').then(m => m.MediascopeModule)
            // },
            { path: 'data-solutions', redirectTo: '/' },
            {
                path: 'planning',
                data: { requiredEntitlement: { entitlement: FeatureMappingEnum.PLANNING } },
                canActivate: [authenticationGuard, entitlementsGuard],
                loadChildren: () => import('./features/mt-reporter/mt-reporter.module').then(m => m.MtReporterModule)
            },
            {
                path: 'folder-management',
                canActivate: [authenticationGuard],
                loadChildren: () => import('./features/tools/tools.module').then(m => m.ToolsModule)
            },
            // Redirects from old paths to new paths for backward compatibility
            // { path: 'datasolutions', redirectTo: 'data-solutions' },
            { path: 'datasolutions', redirectTo: '/' },
            { path: 'reporting', redirectTo: 'planning' }
        ]
    },
    { path: '**', redirectTo: '' }
];
